import PouchDB from 'pouchdb';
import PouchErase from 'pouchdb-erase';
import PouchFind from 'pouchdb-find';

export enum DBS {
  Weeks = 'weeks',
  Workouts = 'workouts',
  FinishedWorkouts = 'finished_workouts',
  UserEvaluations = 'user_evaluations',
}

export class DatabaseManager {

  constructor() {
    PouchDB.plugin(PouchFind).plugin(PouchErase);
  }

  createDbs() {
    Object.values(DBS).forEach(db => {
      new PouchDB(db, {
        adapter: 'idb'
      })
    })
  }

  createIndexes() {
    // TODO: add indexes here
  }

  dropDbs() {
    Object.values(DBS).forEach(db => {
      (new PouchDB(db)).destroy()
    })
  }

}
